"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useNotifContext = exports.NotificationProvider = exports.addNotif = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactHooks = require("@eitje/react-hooks");

var _utils = require("@eitje/utils");

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var NotifContext = _react2.default.createContext({});
var NotifProvider = NotifContext.Provider;

var MAX_NOTIF_AMOUNT_PER_TYPE = 5;

var getNextId = function getNextId(items) {
  if (!items.length) return 1;
  return Math.max.apply(Math, _toConsumableArray(items._map("id"))) + 1;
};

var addNotif = exports.addNotif = function addNotif() {};

var formatNotifKey = function formatNotifKey(item) {
  return item.title + "|" + item.content;
};

var countNotifTypes = function countNotifTypes(notifications) {
  var titleContentCount = {};

  notifications.forEach(function (item) {
    var key = formatNotifKey(item);
    titleContentCount[key] = (titleContentCount[key] || 0) + 1;
  });

  return titleContentCount;
};

var NotificationProvider = exports.NotificationProvider = function NotificationProvider(_ref) {
  var children = _ref.children;

  var _useConcatState = (0, _reactHooks.useConcatState)(),
      _useConcatState2 = _slicedToArray(_useConcatState, 3),
      notifications = _useConcatState2[0],
      setConcatNotifications = _useConcatState2[1],
      removeNotif = _useConcatState2[2];

  var _useConcatState3 = (0, _reactHooks.useConcatState)(),
      _useConcatState4 = _slicedToArray(_useConcatState3, 3),
      centerNotifications = _useConcatState4[0],
      setConcatCenterNotifications = _useConcatState4[1],
      removeCenterNotif = _useConcatState4[2];

  var addNotification = function addNotification(item) {
    var titleContentCount = countNotifTypes(notifications);
    var key = formatNotifKey(item);
    if (!titleContentCount[key] || titleContentCount[key] < MAX_NOTIF_AMOUNT_PER_TYPE) {
      setConcatNotifications(_extends({}, item, { id: _utils2.default.randomId() }));
    }
  };

  var removeNotification = function removeNotification(id) {
    removeNotif(id, "id");
  };

  var addCenterNotification = function addCenterNotification(item) {
    setConcatCenterNotifications(_extends({}, item, {
      id: getNextId(centerNotifications)
    }));
  };

  var removeCenterNotification = function removeCenterNotification(id) {
    removeCenterNotif(id, "id");
  };

  exports.addNotif = addNotif = function addNotif(item) {
    item.position === "center" ? addCenterNotification(item) : addNotification(item);
  };

  var contextValue = {
    notifications: notifications,
    centerNotifications: centerNotifications,
    addNotification: addNotification,
    removeNotification: removeNotification,
    addCenterNotification: addCenterNotification,
    removeCenterNotification: removeCenterNotification
  };

  return _react2.default.createElement(
    NotifProvider,
    { value: contextValue },
    children
  );
};

var useNotifContext = exports.useNotifContext = function useNotifContext() {
  return (0, _react.useContext)(NotifContext);
};